import React, { useState, useEffect, useRef } from 'react';
import {connect} from 'react-redux';
import {closeModal} from '../../../Redux/actions/ui.js';
import FOVInput from '../FOVInput.js';

class Settings3D extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fov: 55,
      controlsInverted: false,
      videoExport: {},
      screenshotExport: {},
    };
    this.getCameraSettings = this.getCameraSettings.bind(this);
    this.setFOV = this.setFOV.bind(this);
    this.toggleControlsInversion = this.toggleControlsInversion.bind(this);
  }

  componentDidMount() {
    this.getCameraSettings();
  }

  getCameraSettings() {
    // Defensive check: only update if Inventum APIs are initialized
    if (!Inventum.camera || !Inventum.video || !Inventum.screenshot) {
      console.warn('Inventum APIs not yet initialized, skipping settings load');
      return;
    }

    this.setState({
      fov: Inventum.camera.getFOV(),
      sceneFOV: Inventum.camera.getSceneFOV(),
      controlsInverted: Inventum.camera.getControlsInvertedStatus(),
      videoExport: Inventum.video.getSettings(),
      screenshotExport: Inventum.screenshot.getSettings(),
    });
  }

  setFOV(value) {
    this.setState({ fov: value });
    if (Inventum.camera) {
      Inventum.camera.setFOV(value);
    }
  }

  toggleControlsInversion() {
    if (Inventum.camera) {
      Inventum.camera.invertControls();
      this.setState({ controlsInverted: !this.state.controlsInverted });
    }
  }

  render() {
    return (
      <div className="LabelsPanel">
        <div className="EditorTabHeader">
          <div className="EditorTabTitle">
            <i className="material-icons notranslate">settings</i>
            <span>Settings</span>
          </div>
        </div>
        <div className="LabelDrawCollection">
          <div className="SettingsEditorContent">
          <div className="SettingsSection">
            <h3 className="SettingsSectionTitle">Camera Settings</h3>
          
          <div className="SettingsGroup">
            <label className="SettingsLabel">Field of View</label>
            <div className="SettingsControl">
              <input
                type="range"
                min="20"
                max="100"
                className="SettingsSlider"
                onChange={(e) => {
                  e.stopPropagation();
                  this.setFOV(parseInt(e.target.value));
                }}
                value={this.state.fov}
              />
              <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <FOVInput
                  value={this.state.fov}
                  min={20}
                  max={100}
                  onChange={(value) => this.setFOV(value)}
                />
                <span className="SettingsValueUnit">°</span>
              </div>
            </div>
          </div>

          <div className="SettingsGroup">
            <label className="SettingsLabel">Controls Inversion</label>
            <div className="SettingsPillGroup">
              <button
                onClick={() => {
                  if (!this.state.controlsInverted) {
                    this.toggleControlsInversion();
                  }
                }}
                className={"SettingsPill" + (this.state.controlsInverted ? " active" : "")}>
                On
              </button>
              <button
                onClick={() => {
                  if (this.state.controlsInverted) {
                    this.toggleControlsInversion();
                  }
                }}
                className={"SettingsPill" + (!this.state.controlsInverted ? " active" : "")}>
                Off
              </button>
            </div>
          </div>
        </div>

        <VideoControls
          settings={this.state.videoExport}
          update={() => {
            this.setState({ videoExport: Inventum.video.getSettings() });
          }}
        />
        <ScreenshotControls
          settings={this.state.screenshotExport}
          update={() => {
            this.setState({ screenshotExport: Inventum.screenshot.getSettings() });
          }}
        />
          </div>
        </div>
      </div>
    );
  }
}

function VideoControls (props) {
	if (Object.keys(props.settings).length === 0) return null;
	const resolutionOptions = [720, 1080, 2160];
	const framerateOptions = [25, 30, 50, 60];
	const bitrateOptions = [25, 50, 75, 100];
	
	return (
		<div className="SettingsSection">
			<h3 className="SettingsSectionTitle">Video Export</h3>
			
			<div className="SettingsGroup">
				<label className="SettingsLabel">Resolution</label>
				<div className="SettingsPillGroup">
					{resolutionOptions.map((value, index) => (
						<button 
							onClick={() => {Inventum.video.setResolution(value); props.update()}} 
							key={index} 
							className={'SettingsPill' + (value === props.settings.videoHeight ? ' active' : '')}>
							{value}p
						</button>
					))}
				</div>
			</div>
			
			<div className="SettingsGroup">
				<label className="SettingsLabel">Frame Rate</label>
				<div className="SettingsPillGroup">
					{framerateOptions.map((value, index) => (
						<button 
							onClick={() => {Inventum.video.setFramerate(value); props.update()}} 
							key={index} 
							className={'SettingsPill' + (value === props.settings.framerate ? ' active' : '')}>
							{value} fps
						</button>
					))}
				</div>
			</div>
			
			<div className="SettingsGroup">
				<label className="SettingsLabel">Bitrate</label>
				<div className="SettingsPillGroup">
					{bitrateOptions.map((value, index) => (
						<button 
							onClick={() => {Inventum.video.setBitrate(value); props.update()}} 
							key={index} 
							className={'SettingsPill' + (value === props.settings.bitrate ? ' active' : '')}>
							{value} Mbps
						</button>
					))}
				</div>
			</div>
		</div>
	)
}

function ScreenshotControls (props) {
	if (Object.keys(props.settings).length === 0) return null;
	const resolutionOptions = [
		{ value: 0, label: 'Auto' },
		{ value: 1080, label: '1080p' },
		{ value: 2160, label: '4K' }
	];
	
	return (
		<div className="SettingsSection">
			<h3 className="SettingsSectionTitle">Screenshot Capture</h3>
			
			<div className="SettingsGroup">
				<label className="SettingsLabel">Resolution</label>
				<div className="SettingsPillGroup">
					{resolutionOptions.map((option, index) => (
						<button 
							onClick={() => {Inventum.screenshot.setResolution(option.value); props.update()}} 
							key={index} 
							className={'SettingsPill' + (option.value === props.settings.resolution ? ' active' : '')}>
							{option.label}
						</button>
					))}
				</div>
				<div className="SettingsHint">Auto uses current viewport resolution</div>
			</div>
		</div>
	)
}


function Settings2D () {
	return (
		<div className="LabelsPanel">
			<div className="EditorTabHeader">
				<div className="EditorTabTitle">
					<i className="material-icons notranslate">settings</i>
					<span>Settings</span>
				</div>
			</div>
			<div className="SettingsEditorContent">
				<div className="SettingsEmptyState">
					<i className="material-icons notranslate">settings</i>
					<p>No settings available in 2D mode</p>
				</div>
			</div>
		</div>
	)
}

function SettingsEditor (props) {
	return props.viewerMode === '2D' ? <Settings2D /> : <Settings3D />;
}

let mapDispatchToProps = dispatch => ({
  closeModal:() => {
    dispatch(closeModal());
  }
})

let mapStateToProps = (state) => ({
	viewerMode: state.sidebarUI.mode,
})

const SettingsEditorContainer = connect(mapStateToProps,mapDispatchToProps)(SettingsEditor)

export default SettingsEditorContainer
